import * as React from 'react';
import * as AvatarPrimitive from '@radix-ui/react-avatar';
import { cn } from './helpers';
import { generateRandomColor } from '@shared/utils/helpers/random-color';

function Avatar({
  className,
  ...props
}: React.ComponentProps<typeof AvatarPrimitive.Root>) {
  return (
    <AvatarPrimitive.Root
      data-slot='avatar'
      className={cn(
        '@container relative flex size-8 shrink-0 overflow-hidden rounded-full',
        className
      )}
      {...props}
    />
  );
}

function AvatarImage({
  className,
  ...props
}: React.ComponentProps<typeof AvatarPrimitive.Image>) {
  return (
    <AvatarPrimitive.Image
      data-slot='avatar-image'
      className={cn('aspect-square object-cover size-full', className)}
      {...props}
    />
  );
}

function AvatarFallback({
  className,
  colorId,
  ...props
}: React.ComponentProps<typeof AvatarPrimitive.Fallback> & {
  colorId?: number;
}) {
  const color = generateRandomColor(colorId ?? 0);

  return (
    <AvatarPrimitive.Fallback
      data-slot='avatar-fallback'
      style={{ backgroundColor: color }}
      className={cn(
        'bg-gray-100 uppercase text-[50cqw] text-white flex size-full items-center justify-center',
        className
      )}
      {...props}
    />
  );
}

export { Avatar, AvatarImage, AvatarFallback };
